<script>
import { mapState } from 'vuex';

export default {
    name: "profile",
    data() {
        return {
            name: '',
            email: '',
            address: '',
            city: '',
            job: '',
            phone: '',
            address_line2: '',
            zip: '',
            country: '',
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['userinfo'])
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        userinfo: {
            handler: function (val) { 
                if (val) { 
                    this.name = val.name;
                    this.email = val.email;
                    this.address = val.address;
                    this.city = val.city;
                    this.job = val.job;
                    this.phone = val.phone;
                    this.address_line2 = val.address_line2;
                    this.zip = val.zip;
                    this.country = val.country;
                }
            },
            immediate: true,
        }
    },
    methods: {
        save() {
            if(this.isLoading){
                return false;
            }
            // if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
            //     this.$refs.email.focus();
            //     this.$showToast({ text: 'Please enter email' }); //请输入邮箱
            //     return false;
            // }
            // if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
            //     this.$refs.email.focus();
            //     this.$showToast({ text: 'Incorrect email format' }); //邮箱格式有误
            //     return false;
            // }
            this.isLoading = true;
            this.$store.dispatch('setInfo', {
                name: this.name,
                // email: this.email,
                address: this.address,
                city: this.city,
                job: this.job,
                phone: this.phone,
                address_line2: this.address_line2,
                zip: this.zip,
                country: this.country,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.$showToast({ text: 'The modification was successful.' }); //密码修改成功
                    this.$store.dispatch('getUserinfo');
                }
                else if (result.code == 90) { 
                    this.$router.replace({
                        path: '/login',
                        query: { redirect: this.$route.fullPath }
                    })
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        }
    },
};
</script>

<template>
    <div class="profile">
        <div class="title">Profile Information</div>
        <div class="wrapper flex">
            <div class="content">
                <div class="input_group">
                    <div class="name">Name</div>
                    <input type="text" name="name" ref="name" v-model="name"/>
                </div>
            </div>
            <div class="content">
                <div class="input_group">
                    <div class="name">Job Title</div>
                    <input type="text" name="job" ref="job" v-model="job"/>
                </div>
            </div>
        </div>
        <div class="wrapper flex">
            <div class="content">
                <div class="input_group">
                    <div class="name">E-Mail</div>
                    <input type="email" name="email" ref="email" disabled v-model="email"/>
                </div>
            </div>
            <div class="content">
                <div class="input_group">
                    <div class="name">Phone</div>
                    <input type="tel" name="phone" ref="phone" v-model="phone"/>
                </div>
            </div>
        </div>
        <div class="wrapper flex">
            <div class="content">
                <div class="input_group">
                    <div class="name">Address</div>
                    <input type="text" name="address" ref="address" v-model="address"/>
                </div>
            </div>
            <div class="content">
                <div class="input_group">
                    <div class="name">Address Line 2</div>
                    <input type="text" name="address_line2" ref="address_line2" v-model="address_line2"/>
                </div>
            </div>
        </div>
        <div class="wrapper flex">
            <div class="content">
                <div class="input_group">
                    <div class="name">City</div>
                    <input type="text" name="city" ref="city" v-model="city"/>
                </div>
            </div>
            <div class="content">
                <div class="wrapper flex">
                    <div class="content">
                        <div class="input_group">
                            <div class="name">Zip</div>
                            <input type="text" name="zip" ref="zip" v-model="zip"/>
                        </div>
                    </div>
                    <div class="content">
                        <div class="input_group">
                            <div class="name">Country</div>
                            <input type="text" name="country" ref="country" v-model="country"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn flex_center" @click="save">Update Profile</div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    gap: .2rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: 0;
    }
    .content{
        flex: 1;
    }
    .title{
        font-size: .24rem;
        margin-bottom: .3rem;
    }
}
.input_group{
    margin-bottom: .25rem;
    .name{
        font-size: .16rem;
        color: #666;
        margin-bottom: .15rem;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
    }
    input{
        width: 100%;
        height: .5rem;
        border: 1px solid #c9c9c9;
        background: #fff;
        border-radius: .05rem;
        padding: 0 .25rem;
        font-size: .16rem;
        outline: none;
        color: #666;
        box-sizing: border-box;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
    }
}
.btn{
    font-size: .24rem;
    background: var(--background-color);
    color: var(--color-blue);
    width: 2.2rem;
    height: .4rem;
    border-radius: .4rem;
    cursor: pointer;
    font-weight: bold;
    @media only screen and (max-width: 750px) {
        margin: 0 auto;
        width: 2.8rem;
        height: .5rem;
        font-size: .28rem;
    }
}
</style>